/** Property data uses the literal strings "false" / "null" for empty values. */
export function hasValue(value: unknown): value is string {
  if (value == null) return false;
  const s = String(value).trim().toLowerCase();
  return s !== '' && s !== '-' && s !== 'false' && s !== 'null' && s !== 'undefined';
}

export function isExternalUrl(url: string | null | undefined): boolean {
  return !!url && /^https?:\/\//i.test(url);
}

/** Opens off-site links in a new tab unless the editor set an explicit target. */
export function linkTarget(url: string | null | undefined, target: string | null | undefined): string {
  if (hasValue(target) && target !== '_self') return target;
  return isExternalUrl(url) ? '_blank' : '_self';
}

const btnBase =
  'inline-flex items-center justify-center gap-2 px-7 py-3 min-h-[48px] font-heading text-[17px] font-bold uppercase leading-none tracking-[0.01em] text-center no-underline js-btn focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2';

/** Filled rust button (the site's primary CTA). */
export const btnPrimary = `${btnBase} border border-primary bg-primary text-[color:var(--vibe-color-text-on-primary)] hover:border-secondary hover:bg-secondary hover:text-[color:var(--vibe-color-text-on-secondary)] focus-visible:outline-primary`;
